import React, { Component } from 'react';
import {
    Col,
    Divider,
    Icon,
    Row,
    Typography
} from 'antd';
const { Text, Title } = Typography;

class Sidebar extends Component {
    render() {
        return (
            <Col md={8} span={24}>
                <Row className='sidebar-card'>
                    <h1><strong>B File Essential Plan</strong></h1>
                    <Title style={{ fontWeight: 700, fontSize: 24, color: 'black' }}>
                        $850<span style={{ fontSize: '16px', color: '#888' }}>/mo</span>
                    </Title>
                    <p style={{ fontSize: 10, fontFamily: 'sans-serif' }}>*12 - Month Commitment</p>
                    <p>
                        Our essential plan to kick-start growing your book of business through a proven process and the staffing support to scale.
                    </p>
                    <ul className="checkList">
                        <b>
                            <li style={{ marginBottom: 10 }}>Dedicated Appointment Coordinator to schedule your annual reviews</li>
                            <li style={{ marginBottom: 10 }}>B File Risk Assessment Software</li>
                        </b>
                        <li>
                            <b>Dedicated Follow-Up Specialist for Call List Support, including:</b>
                            <ul>
                                <li>Thank You</li>
                                <li>Follow-Up Opportunity Calls:
                                    <ul>
                                        <li>Life Insurance</li>
                                        <li>P&C Cross Sell</li>
                                        <li>Retirement</li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </Row>
                <Row className='sidebar-card' style={{ marginTop: 20 }}>
                    <h1><strong>Uncover More:</strong></h1>
                    <ul className="checkList">
                        <b>
                            <li style={{ marginBottom: 10 }}>Personal Umbrella Opportunities</li>
                            <li style={{ marginBottom: 10 }}>Life Insurance Opportunities</li>
                            <li style={{ marginBottom: 10 }}>Cross-Sell Opportunities</li>
                            <li>Retirement Opportunities</li>
                        </b>
                    </ul>
                    <h1><strong>All Subscriptions</strong></h1>
                    <ul className="checkList">
                        {/* <li>30 in 30 money-back guarantee</li> */}
                        <b>
                            <li style={{ marginBottom: 10 }}>Live Training</li>
                            <li>Unlimited Users</li>
                        </b>
                    </ul>
                </Row>
            </Col>
        );
    }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/scenes/Register/parts/sidebar-updated.js